<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        from: null,
        to: null,
      }),
    },
    format: {
      type: String,
      default: 'dd.MM.yyyy',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Date,
      default: () => new Date(1900, 1, 1),
    },
    max: {
      type: Date,
      default: () => new Date(2099, 1, 1),
    },
  },
  computed: {
    __value: {
      get() {
        if (!this.value?.from) {
          return [];
        }
        if (!this.value.to) {
          return [this.value.from];
        }
        return [this.value.from, this.value.to];
      },
      set(value) {
        this.value.from = value[0] || null;
        this.value.to = value[1] || null;
        this.$emit('input', this.value);
      },
    },
    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate,
      };
    },
  },
  methods: {
    handlerInput(value) {
      this.__value = value;
    },
    disabledDate(date) {
      const time = date.getTime();
      if (time > this.max.getTime()) {
        return true;
      }
      if (time < this.min.getTime()) {
        return true;
      }
      return false;
    },
  },
};
</script>
<template>
  <el-date-picker
    class="f-c-date-range"
    :value="__value"
    format="dd.MM.yyyy"
    :disabled="disabled"
    :picker-options="pickerOptions"
    type="daterange"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="handlerInput"
    @change="$emit('change', value)"
    :clearable="false"
    range-separator="по">
  </el-date-picker>
</template>
<style lang="scss">
  .f-c-date-range {

    &.el-date-editor {
      width: 100%;
      height: 24px;
      padding: 0;
      flex-shrink: 0;
      border: none;
      display: flex;
      background: none;

      .el-range__icon {
        display: none;
      }

      .el-range-separator {
        line-height: 24px;
        flex-shrink: 0;
        display: block;
        width: 24px;
        font-size: 16px;
        padding: 0;
        text-align: center;
        height: 24px;
      }

      .el-range-input {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        height: 24px;
        display: block;
        padding: 0;
        color: #333333;
        overflow: hidden;
        background: none;
      }

      .el-range__close-icon {
        display: none;
      }
    }

  }

  body {
    .el-date-table td.in-range div {
      background-color: #00000033;
    }

    .el-date-table td.in-range div:hover {
      background-color: #00000033;
    }

    .el-date-table td.disabled div {
      background-color: #ffffff11;
      opacity: 1;
      cursor: not-allowed;
      color: #ffffff55;
    }

    .el-date-range-picker {

    }
  }

  @media (max-width: 700px) {
    body {
      .el-date-range-picker {
        width: 256px;
        overflow: hidden;

        .el-picker-panel__body {
          min-width: 100%;
          position: relative;
        }
      }

      .el-date-range-picker__content.is-left {
        width: 100%;
        border-right: none;
      }

      .el-date-range-picker__content.is-right {
        padding: 0;
        position: static;

        .el-date-table {
          display: none;
        }

        .el-date-range-picker__header {
          width: 50px;
          position: absolute;
          right: 16px;
          top: 16px;

          & > div {
            display: none;
          }
        }
      }
    }
  }
</style>
